import BannerSettingsContainer from './BannerSettingsContainer';

export default BannerSettingsContainer;
